export const CHANGE_ABLE_TO_SEE_MODIFY_PATIENT_INFO = 'CHANGE_ABLE_TO_SEE_MODIFY_PATIENT_INFO';
export type CHANGE_ABLE_TO_SEE_MODIFY_PATIENT_INFO = typeof CHANGE_ABLE_TO_SEE_MODIFY_PATIENT_INFO;

export const CHANGE_ABLE_TO_SEE_MODIFY_PREFERRED_PHARMACY = 'CHANGE_ABLE_TO_SEE_MODIFY_PREFERRED_PHARMACY';
export type CHANGE_ABLE_TO_SEE_MODIFY_PREFERRED_PHARMACY = typeof CHANGE_ABLE_TO_SEE_MODIFY_PREFERRED_PHARMACY;

export const CHANGE_REGION_CODE_CONFIRMATION_REQUIREMENT = 'CHANGE_REGION_CODE_CONFIRMATION_REQUIREMENT';
export type CHANGE_REGION_CODE_CONFIRMATION_REQUIREMENT = typeof CHANGE_REGION_CODE_CONFIRMATION_REQUIREMENT;

export const CHANGE_DISPLAY_PROFILE_PICTURES_DURING_APPOINTMENT_CONFIRMATION_VALUE = 'CHANGE_DISPLAY_PROFILE_PICTURES_DURING_APPOINTMENT_CONFIRMATION_VALUE';
export type CHANGE_DISPLAY_PROFILE_PICTURES_DURING_APPOINTMENT_CONFIRMATION_VALUE = typeof CHANGE_DISPLAY_PROFILE_PICTURES_DURING_APPOINTMENT_CONFIRMATION_VALUE;

export const CHANGE_HEALTHCARD_EXPIRATION_REDIRECT_TO_RECEPTION = 'CHANGE_HEALTHCARD_EXPIRATION_REDIRECT_TO_RECEPTION';
export type CHANGE_HEALTHCARD_EXPIRATION_REDIRECT_TO_RECEPTION = typeof CHANGE_HEALTHCARD_EXPIRATION_REDIRECT_TO_RECEPTION;

export const CHANGE_PATIENT_ABLE_BOOK_NEW_APPOINTMENT = 'CHANGE_PATIENT_ABLE_BOOK_NEW_APPOINTMENT';
export type CHANGE_PATIENT_ABLE_BOOK_NEW_APPOINTMENT = typeof CHANGE_PATIENT_ABLE_BOOK_NEW_APPOINTMENT;

export const UPDATE_LANGUAGE_SELECTION_LIST = 'UPDATE_LANGUAGE_SELECTION_LIST';
export type UPDATE_LANGUAGE_SELECTION_LIST = typeof UPDATE_LANGUAGE_SELECTION_LIST;

export const CHANGE_DEFAULT_LANGUAGE = 'CHANGE_DEFAULT_LANGUAGE';
export type CHANGE_DEFAULT_LANGUAGE = typeof CHANGE_DEFAULT_LANGUAGE;

export const CHANGE_ADMIN_SETTING_NUMBER_FIELD = 'CHANGE_ADMIN_SETTING_NUMBER_FIELD_FACTION';
export type CHANGE_ADMIN_SETTING_NUMBER_FIELD = typeof CHANGE_ADMIN_SETTING_NUMBER_FIELD;

export const SELECT_CURRENT_SITE = 'SELECT_CURRENT_SITE';
export type SELECT_CURRENT_SITE = typeof SELECT_CURRENT_SITE;

export const UPDATE_SITE_SELECTION_LIST = 'UPDATE_SITE_SELECTION_LIST';
export type UPDATE_SITE_SELECTION_LIST = typeof UPDATE_SITE_SELECTION_LIST;

export const CHANGE_APPOINTMENT_TIME_RANGE_VALUE = 'CHANGE_APPOINTMENT_TIME_RANGE_VALUE';
export type CHANGE_APPOINTMENT_TIME_RANGE_VALUE = typeof CHANGE_APPOINTMENT_TIME_RANGE_VALUE;




// WEBPACK FOOTER //
// ./src/store/AdminOptions/constant.ts